export default __webpack_public_path__ + "static/media/prev-NavIC-Clock-5.f99568e7.png";